import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=b5497608&"
import script from "./ProductDialog.vue?vue&type=script&lang=js&"
export * from "./ProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=b5497608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports